// extracted by mini-css-extract-plugin
module.exports = {"root":"_61d3c22766c393e4224559708ed42770"};